import type { GenerateAsBuiltBody } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18next from 'i18next';
import { useCallback } from 'react';

import { keycloak } from '../keycloak';
import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
}

export function useGenerateAsBuilt({ projectId }: Params) {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ filename, plans, moveToOperative }: GenerateAsBuiltBody) =>
      post({
        url: `/projects/${projectId}/documentation/as-built`,
        body: {
          filename,
          language: i18next.language,
          plans,
          moveToOperative,
          token: keycloak.token,
        },
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.getAsBuiltDocs(projectId),
      }),
  });

  const generateAsBuilt = useCallback((params: GenerateAsBuiltBody) => mutate(params), [mutate]);

  return {
    generateAsBuilt,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
